<template>
  <div v-if="onepagers.length > 0">
    <document-container
        :body="[]" :footer="[]"

        documentType="emissions-cover" orientation="landscape"
    >
      <template #raw-header>
        <header class="raw-header">
          <!--          <div class="header-disclaimer">-->
          <!--            <strong>WERBEMITTEILUNG</strong>-->
          <!--            <div style="top:6px;position:relative"></div>-->
          <!--          </div>-->
          <img
              :src="logo" alt="" class="logo"
          >
        </header>
      </template>
      <div
          slot="raw-body" class="page-block"
      >
        <div class="heading">
          <h1>PRIVATE BANKING ZERTIFIKATE</h1>
          <h2>EMISSIONSKALENDER</h2>
        </div>
        <!--        <div class="page-disclaimer">-->
        <!--          Rechtliche Hinweise: <br> Diese Information ist als Werbung im Sinne des Wertpapierhandelsgesetzes und der EU-Prospektverordnung anzusehen. Das heißt, sie genügt nicht den rechtlichen Anforderungen für Finanzinstrumente und Vermögensanlagen. Es handelt sich um die unveränderte Weitergabe einer Marktidee bzw. einer sonstigen Marktinformation durch die Sie betreuende Sparkasse. Bezüglich weiterer Informationen sowie der Offenlegung möglicher Interessenkonflikte wird auf die Homepage Ihrer Sparkasse verwiesen. Die Publikation stellt keine Anlageberatung oder Handlungsempfehlung in Bezug auf die genannten Finanzinstrumente bzw. Vermögensanlagen seitens der Sparkasse dar. Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.-->
        <!--          <br> Die genannten Finanzinstrumente bzw. Vermögensanlagen werden lediglich in Kurzform beschrieben. Eine Anlageentscheidung sollte nur auf Grundlage der Informationen in den rechtlich verbindlichen Dokumenten wie dem Wertpapier- oder Verkaufsprospekt, den Endgültigen Bedingungen, dem Basisinformationsblatt und den Jahres- bzw. Halbjahresberichten der Vermögensanlagen erfolgen, die Sie bei Ihrer Sparkasse, auf Verlangen in Papierform, kostenlos erhalten.-->
        <!--        </div>-->
      </div>
      <!--      <div-->
      <!--          slot="raw-footer"-->
      <!--          class="page-block"-->
      <!--      >-->
      <!--        <div class="disclaimer-date">-->
      <!--          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}-->
      <!--        </div>-->
      <!--      </div>-->
    </document-container>
    <div :class="environment" class="onepager-container emissions">
      <onepager
          v-for="onepager in onepagers" :key="onepager.type" :environment="environment" :logo="logo" :multiRowPath="onepager.multiRowPath" :products="onepager.products" :tableConfig="onepager.tableConfig" :template="getTemplateManager(onepager.template)" :type="onepager.type"
      ></onepager>
    </div>

    <document-container
        :body="[]" :footer="[]" :header="[{
    'type': 'Pagetitle',
    'position': 'header',

   'title': 'Haftungsausschluß',
    }]" :logo="logo" documentType="onepager" orientation="landscape"
    >
      <div
          slot="raw-body" class="page-block"
      >
        <p>
          Die in diesem Zeichnungskalender enthaltenen Informationen richten sich ausschließlich an Kreditinstitute, Finanzdienstleistungsinstitute und sonstige professionelle Marktteilnehmer und dienen ausschließlich Informations- und Vertriebsunterstützungszwecken.
        </p>
        <p>
          Die Informationen stellen weder eine Anlageberatung noch eine Anlageempfehlung oder Finanzanalyse im Sinne von MiFID II, des Wertpapierhandelsgesetzes (WpHG) oder der Marktmißbrauchsrichtlinie (MAR) dar und sind weder als Angebot noch als Aufforderung zum Kauf oder Verkauf von Finanzinstrumenten zu verstehen.
        </p>
        <p>
          Eine Prüfung der Geeignetheit oder Angemessenheit für den jeweiligen Endkunden erfolgt nicht. Diese liegt ausschließlich in der Verantwortung des jeweils beratenden bzw. vertreibenden Instituts. Maßgeblich für eine Anlageentscheidung sind ausschließlich die jeweiligen Emissionsunterlagen, insbesondere die Endgültigen Bedingungen, der Basisprospekt sowie das Basisinformationsblatt (KID). Die dargestellten Informationen berücksichtigen keine individuellen Anlageziele, die finanzielle Situation oder die Kenntnisse und Erfahrungen von Anlegern.
        </p>
        <p>
          Eine Haftung für die Vollständigkeit und Richtigkeit der Angaben wird, soweit gesetzlich zulässig, nicht übernommen.
        </p>
        <!--        <div class="page-disclaimer">-->
        <!--          Rechtliche Hinweise: <br> Diese Information ist als Werbung im Sinne des Wertpapierhandelsgesetzes und der EU-Prospektverordnung anzusehen. Das heißt, sie genügt nicht den rechtlichen Anforderungen für Finanzinstrumente und Vermögensanlagen. Es handelt sich um die unveränderte Weitergabe einer Marktidee bzw. einer sonstigen Marktinformation durch die Sie betreuende Sparkasse. Bezüglich weiterer Informationen sowie der Offenlegung möglicher Interessenkonflikte wird auf die Homepage Ihrer Sparkasse verwiesen. Die Publikation stellt keine Anlageberatung oder Handlungsempfehlung in Bezug auf die genannten Finanzinstrumente bzw. Vermögensanlagen seitens der Sparkasse dar. Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.-->
        <!--          <br> Die genannten Finanzinstrumente bzw. Vermögensanlagen werden lediglich in Kurzform beschrieben. Eine Anlageentscheidung sollte nur auf Grundlage der Informationen in den rechtlich verbindlichen Dokumenten wie dem Wertpapier- oder Verkaufsprospekt, den Endgültigen Bedingungen, dem Basisinformationsblatt und den Jahres- bzw. Halbjahresberichten der Vermögensanlagen erfolgen, die Sie bei Ihrer Sparkasse, auf Verlangen in Papierform, kostenlos erhalten.-->
        <!--        </div>-->
      </div>
      <!--      <div-->
      <!--          slot="raw-footer"-->
      <!--          class="page-block"-->
      <!--      >-->
      <!--        <div class="disclaimer-date">-->
      <!--          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}-->
      <!--        </div>-->
      <!--      </div>-->
    </document-container>
  </div>
</template>

<script>
import Onepager from '../onepager/Onepager'
import ProductService from "../../service/ProductService"
import ConfigService from "../../service/ConfigService"
import { EventBus } from "../../service/EventBus"
import TemplateManager from '../../service/TemplateManager'
import TokenService from "../../service/TokenService"
import DocumentContainer from "../document/DocumentContainer"

export default {
  name: 'emissions',

  // vue-head is used to set & update the css
  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: `/config/${this.environment}/style/emissions.css`,
        },
      ]
    },
  },

  components: {
    DocumentContainer,
    Onepager,
  },

  data: function () {
    return {
      onepagers: [],
      pageCounter: 0,
      token: null, customOrder: [
        {
          "type": 'bond',
          "order": [
            'default',
          ],
        },
        {
          "type": 'derivate',
          "order": [
            'QTE0',
            'QTEM',
            'QTEF',
            'QTG0',
            'QTGE',
            'QTPD',
            'QTM0',
          ],
        },
      ],
    }
  },

  props: {
    environment: {
      type: String,
      required: true,
    },
    productIds: {
      type: String,
      required: true,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },

  methods: {
    getCustomSortOrder(instrumentType) {
      const orderConfig = this.customOrder.find(config => config.type.toLowerCase() === instrumentType.toLowerCase())
      return orderConfig ? orderConfig.order : []
    },
    sortByCustomOrder(items, customOrder) {
      return items.sort((a, b) => {
        const aIndex = customOrder.indexOf(a.type)
        const bIndex = customOrder.indexOf(b.type)

        // Items in custom order come first, sorted by order
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex
        if (aIndex !== -1) return -1
        if (bIndex !== -1) return 1
        // Items not in custom order maintain their relative order
        return 0
      })
    },
    getTemplateManager(template) {
      return new TemplateManager(template)
    },
    fetchProducts() {
      ProductService.getProductsFromBroker(
          this.environment,
          this.appInstance,
          this.productIds.split('+'),
          this.token,
          'DERICON_EMISSIONS',
      ).then(result => {
            const typeMap = {
              BOND: 'emissions_bonds',
              DERIVATE: 'emissions',
            }

            // Group promises by instrument type to maintain bonds before derivates
            const allPromises = result.data.data.map(instrumentType => {
              const customOrder = this.getCustomSortOrder(instrumentType.type)

              let sortedResult = this.sortByCustomOrder(
                  instrumentType.onepagers.reduce((sum, el) => {
                    let idx = sum.map(el => el.type).indexOf(el.type)

                    if (idx >= 0 && !(el.type === 'QTR0')) {
                      sum[idx].products = [...sum[idx].products, ...el.products]
                    } else {
                      sum.push(el)
                    }

                    return sum
                  }, []),
                  customOrder,
              )

              console.log(sortedResult)

              // Collect all promises for this instrument type
              const configPromises = sortedResult.map(productsByType => {
                return ConfigService.getDocumentConfig(
                    this.environment,
                    typeMap[instrumentType.type],
                    'default',
                    productsByType.type ? productsByType.type : 'default',
                ).then(documentConfig => {
                  return {
                    template: documentConfig.data,
                    products: instrumentType.type === 'DERIVATE' ? this._.sortBy(productsByType.products, (product) => {
                      return product.derived.underlying.name || ''
                    }) : productsByType.products,
                    tableConfig: productsByType.columns,
                    multiRowPath: productsByType.pathToMultiRowCount,
                    type: productsByType.type,
                    instrumentType: instrumentType.type,
                  }
                })
              })

              return {
                instrumentType: instrumentType.type,
                promises: configPromises,
                customOrder: customOrder,
              }
            })

            // Process all instrument types, maintaining bonds before derivates
            const processByInstrumentType = (instrumentGroups) => {
              if (instrumentGroups.length === 0) return

              const group = instrumentGroups[0]
              const remaining = instrumentGroups.slice(1)

              Promise.all(group.promises).then(onepagersData => {
                // Sort the results by the custom order
                const sortedOnepagers = onepagersData.sort((a, b) => {
                  const aIndex = group.customOrder.indexOf(a.type)
                  const bIndex = group.customOrder.indexOf(b.type)

                  if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex
                  if (aIndex !== -1) return -1
                  if (bIndex !== -1) return 1
                  return 0
                })

                sortedOnepagers.forEach(onepager => {
                  this.onepagers.push(onepager)
                })

                // Process next instrument type
                processByInstrumentType(remaining)
              })
            }

            // Sort instrument types so BOND comes before DERIVATE
            const sortedInstrumentGroups = allPromises.sort((a, b) => {
              if (a.instrumentType === 'BOND') return -1
              if (b.instrumentType === 'BOND') return 1
              return 0
            })

            processByInstrumentType(sortedInstrumentGroups)
          },
      )
    },
  },

  computed: {
    logo() {
      if (this.environment === 'hanvb') {
        return ['config', this.environment, 'images', this.$route.query.context === 'OFFERTE_DEFAULT' ? 'offerte_logo.jpg' : 'offerte_logo_info.jpg'].join('/')
      } else {
        return ['config', this.environment, 'images', 'logo.png'].join('/')
      }
    },
  },

  async created() {
    if (!this.$route.query.token) {
      this.token = await TokenService.checkToken()
    } else {
      this.token = this.$route.query.token
    }
    this.fetchProducts()
  },

  mounted() {
    EventBus.$on('pageCounter', amount => {
      this.pageCounter += amount
    })
  },

  watch: {
    // changes in the url are applied instantaneously
    environment() {
      this.$emit('updateHead')
    },
    productIds() {
      this.onepagers = []
      this.fetchProducts()
    },
    // token() {
    //   this.fetchProducts()
    // }
  },
}
</script>

<style lang="scss">
.emissions {
  .product-table-title {
    display: none;
  }

  th:first-child,
  td:first-child {
    padding-left: 0 !important;
  }

  th:last-child,
  td:last-child {
    padding-right: 0 !important;
  }
}

.emissions-cover {
  background-color: #2c3e5d;

  .logo {
    filter: brightness(0) invert(1);
  }

  .heading {

    position: absolute;
    width: 100%;

    h1 {
      position: absolute;
      top: 283px;
      color: #fff !important;
      font-size: 50px !important;
      font-weight: 300 !important;
      line-height: 100%;
      margin: 0 !important;
    }

    h2 {
      color: #fff !important;
      font-size: 24px !important;
      font-weight: 600 !important;
      top: 350px;
      position: absolute;
    }
  }

  h3 {
    font-weight: 600 !important;
    font-size: 10px !important;
    color: #000 !important;
    margin-bottom: 8px !important;
    margin-top: 0 !important;
  }

  .page-title h1,
  h2 {
    font-weight: 700 !important;
    font-size: 16px;
    line-height: 100%;
    margin: 0 !important;
    text-transform: uppercase;
  }

  .page-number {
    color: #fff !important;
  }

}
</style>



// WEBPACK FOOTER //
// Emissions.vue?062df5d1